

































































































































import { Component } from 'vue-property-decorator';
import GiganautVue from '@/components/Shared/GiganautVue';
import { ManagementReportsModule } from '@/store/modules/managementReports';
import { formatCurrency, formatPercent, formatNumber, formatHours } from '@/lib/reportFormatters';

@Component({ name: 'CompanyReports' })
export default class CompanyReports extends GiganautVue {

  get companyLabel(): string { return this.Labels.company || 'Company'; }
  get companiesLabel(): string { return this.Labels.companies || 'Companies'; }
  get locationsLabel(): string { return this.Labels.locations || 'Locations'; }

  get overviewHeaders() {
    return [
      { text: this.companyLabel, value: 'companyName' },
      { text: 'Revenue', value: 'revenue', align: 'end' },
      { text: 'GP', value: 'gp', align: 'end' },
      { text: 'Margin', value: 'margin', align: 'end' },
      { text: 'Bookings', value: 'bookings', align: 'end' },
      { text: this.locationsLabel, value: 'locations', align: 'end' },
      { text: 'Contacts', value: 'contacts', align: 'end' },
    ];
  }

  get dormancyHeaders() {
    return [
      { text: this.companyLabel, value: 'companyName' },
      { text: 'Status', value: 'status' },
      { text: 'Days Since Booking', value: 'daysSinceBooking', align: 'end' },
      { text: 'Last 12M Revenue', value: 'last12MonthRevenue', align: 'end' },
    ];
  }

  get profitHeaders() {
    return [
      { text: this.companyLabel, value: 'companyName' },
      { text: 'Revenue', value: 'revenue', align: 'end' },
      { text: 'GP', value: 'gp', align: 'end' },
      { text: 'Margin', value: 'margin', align: 'end' },
      { text: 'Hours', value: 'hours', align: 'end' },
      { text: 'Shifts', value: 'shifts', align: 'end' },
    ];
  }

  get companyOverview() { return ManagementReportsModule.companyOverview; }
  get companyDormancy() { return ManagementReportsModule.companyDormancy; }
  get companyProfitability() { return ManagementReportsModule.companyProfitability; }

  dormancyColor(status: string): string {
    switch (status) {
      case 'active': return 'green';
      case 'cooling': return 'amber darken-2';
      case 'dormant': return 'orange';
      case 'lost': return 'red';
      default: return 'grey';
    }
  }

  fmtCurrency(v: number) { return formatCurrency(v); }
  fmtPct(v: number) { return formatPercent(v); }
  fmtNum(v: number) { return formatNumber(v); }
  fmtHours(v: number) { return formatHours(v); }
}
